module.exports = __webpack_public_path__ + "img/daizy_warehouse.41f630af.jpg";